var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 26.6663V23.333M15.4999 16.6663V13.333M13.8333 14.9997H17.1666M13.8333 24.9997H17.1666M21.1666 13.9997L20.0105 17.0056C19.8225 17.4944 19.7285 17.7388 19.5823 17.9444C19.4527 18.1266 19.2935 18.2858 19.1113 18.4154C18.9057 18.5615 18.6613 18.6555 18.1725 18.8436L15.1666 19.9997L18.1725 21.1558C18.6613 21.3438 18.9057 21.4378 19.1113 21.584C19.2935 21.7135 19.4527 21.8727 19.5823 22.055C19.7285 22.2605 19.8225 22.5049 20.0105 22.9938L21.1666 25.9997L22.3227 22.9938C22.5107 22.5049 22.6047 22.2605 22.7509 22.055C22.8805 21.8727 23.0397 21.7135 23.2219 21.584C23.4274 21.4378 23.6719 21.3438 24.1607 21.1558L27.1666 19.9997L24.1607 18.8436C23.6719 18.6555 23.4274 18.5615 23.2219 18.4154C23.0397 18.2858 22.8805 18.1266 22.7509 17.9444C22.6047 17.7388 22.5107 17.4944 22.3227 17.0056L21.1666 13.9997Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.9e858822a3f72830ab3c664e07ab97f3.svg";
export { ForwardRef as ReactComponent };